import { FormControl, FormLabel, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function MonthOfYearField(props) {
    const { value, onChange } = props;
    const { t } = useTranslation();

    return (
        <Box>
            <FormLabel>{t('recurrence.field.monthOfYear.label')}</FormLabel>
            <br/>
            <FormControl sx={{m: 1, minWidth: 150}}>
                <Select
                    value={value}
                    onChange={onChange}
                >
                    <MenuItem value={1}>{t('recurrence.month.january')}</MenuItem>
                    <MenuItem value={2}>{t('recurrence.month.february')}</MenuItem>
                    <MenuItem value={3}>{t('recurrence.month.march')}</MenuItem>
                    <MenuItem value={4}>{t('recurrence.month.april')}</MenuItem>
                    <MenuItem value={5}>{t('recurrence.month.may')}</MenuItem>
                    <MenuItem value={6}>{t('recurrence.month.june')}</MenuItem>
                    <MenuItem value={7}>{t('recurrence.month.july')}</MenuItem>
                    <MenuItem value={8}>{t('recurrence.month.august')}</MenuItem>
                    <MenuItem value={9}>{t('recurrence.month.september')}</MenuItem>
                    <MenuItem value={10}>{t('recurrence.month.october')}</MenuItem>
                    <MenuItem value={11}>{t('recurrence.month.november')}</MenuItem>
                    <MenuItem value={12}>{t('recurrence.month.december')}</MenuItem>
                </Select>
            </FormControl>
        </Box>

    )
}

MonthOfYearField.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};
